export default __webpack_public_path__ + "static/media/330_dummy2016-hilfsprojekt01-de-mobile.0128cf59.png";